unable to read source [project]/node_modules/.pnpm/posthog-js@1.364.6/node_modules/posthog-js/react/src/context/posthog-default.ts